export type VoucherShareReservation = {
  departamento?: string | number | null;
};

export const buildVoucherShareText = (
  reservation: VoucherShareReservation,
  direccion?: string | null
) => {
  const departamento = String(reservation.departamento || "").trim() || "-";
  const direccionLine = direccion?.trim()
    ? `Dirección: *${direccion.trim()}*`
    : "Dirección: ver detalle en el archivo adjunto";

  return [
    "A continuación envío la información de su estadía.",
    "",
    `Alojamiento: Depto ${departamento}`,
    direccionLine,
    "",
    "En el archivo adjunto encontrará las fechas, los horarios de check-in y check-out, y el detalle del pago.",
  ].join("\n");
};
